import React, { useState, memo } from "react";
import Select from "react-select";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Input } from "reactstrap";
import { useSelector } from "react-redux";

function ProjectModules({ modules, setModules, projectid }) {
  const { KanbanBoardData } = useSelector((state) => state.user);

  const fmodule = KanbanBoardData?.filter(
    (x) => x.ProjectId === projectid && x.ModuleLinked != null
  )
    ?.map((x) => x.ModuleLinked)
    ?.filter(
      (value, index, self) =>
        self.findIndex((v) => v.FullName === value.FullName) === index
    )
    ?.map((x) => x.FullName);

  const options = [
    { label: "Monolith", value: "Monolith" },
    { label: "Frontend", value: "Frontend" },
    { label: "Backend", value: "Backend" },
    { label: "API Service", value: "API Service" },
    { label: "Microservice", value: "Microservice" },
  ];

  const addModule = () => {
    setModules((prevModules) => [
      ...prevModules,
      { Name: "", Type: "", FullName: "" },
    ]);
  };

  const updateModule = (index, updatedData) => {
    setModules((prevModules) =>
      prevModules.map((module, i) =>
        i === index ? { ...module, ...updatedData } : module
      )
    );
  };

  const removeModule = (indexToRemove) => {
    setModules((prevModules) =>
      prevModules.filter((_, index) => index !== indexToRemove)
    );
  };

  return (
    <div>
      <table style={{ width: "100%", gap: 10 }}>
        <thead>
          <tr>
            <th>
              <label className="SprintlabelStyle">Module Name</label>
            </th>
            <th>
              <label className="SprintlabelStyle">Module Type</label>
            </th>
            <th>
              <label className="SprintlabelStyle">Module FullName</label>
            </th>
            <ControlPointIcon
              style={{ color: "green", cursor: "pointer" }}
              onClick={addModule}
            />
          </tr>
        </thead>
        <tbody>
          {modules.map((module, index) => (
            <MemoizedModuleRow
              key={`module-${index}`}
              module={module}
              fmodule={fmodule}
              options={options}
              onUpdate={(updatedData) => updateModule(index, updatedData)}
              onRemove={() => removeModule(index)}
              disableRemove={modules.length === 1}
            />
          ))}
        </tbody>
      </table>
      <label className="mb-3" style={{ fontSize: 10 }}>
        Note: Module is optional, but good to create for end-to-end connected
        view of platform engineering.
      </label>
    </div>
  );
}

const ModuleRow = ({
  module,
  fmodule,
  options,
  onUpdate,
  onRemove,
  disableRemove,
}) => {
  const [localName, setLocalName] = useState(module.Name);
  const [localType, setLocalType] = useState(module.Type);
  const [localFullName, setLocalFullName] = useState(module.FullName);

  const handleNameChange = (e) => {
    setLocalName(e.target.value.replace(/[^a-zA-Z0-9]/g, ""));
  };

  const handleNameBlur = () => {
    onUpdate({
      Name: localName,
      FullName: `${localName}_${localType || ""}`,
    });
  };

  const handleTypeChange = (selectedOption) => {
    const updatedType = selectedOption.value;
    setLocalType(updatedType);
    onUpdate({
      Type: updatedType,
      FullName: `${localName || ""}_${updatedType}`,
    });
  };

  const handleFullNameChange = (e) => {
    const updatedFullName = e.target.value;
    setLocalFullName(updatedFullName);
  };

  const handleFullNameBlur = () => {
    onUpdate({ FullName: localFullName });
  };

  return (
    <tr>
      <td style={{ width: "30%", marginRight: 10 }}>
        <Input
          disabled={fmodule?.includes(module.FullName)}
          placeholder="Enter Title"
          value={localName}
          onChange={handleNameChange}
          onBlur={handleNameBlur}
          type="text"
          style={{ borderRadius: 14, height: 40 }}
          className="inpui SprintFormFields"
          size="small"
        />
      </td>
      <td style={{ width: "30%", marginRight: 10 }}>
        <Select
          options={options}
          value={options.find((option) => option.value === localType)}
          onChange={handleTypeChange}
          isSearchable
        />
      </td>
      <td style={{ marginRight: 100 }}>
        <Input
          placeholder="FullName"
          value={localFullName || ""}
          onChange={handleFullNameChange}
          onBlur={handleFullNameBlur}
          type="text"
          style={{ borderRadius: 14, height: 40 }}
          className="inpui SprintFormFields"
          size="small"
        />
      </td>
      <td>
        {!disableRemove && (
          <RemoveCircleOutlineIcon
            style={{ color: "red", cursor: "pointer" }}
            onClick={onRemove}
          />
        )}
      </td>
    </tr>
  );
};

const MemoizedModuleRow = memo(ModuleRow);

export default ProjectModules;
